import { EventFilters, HistoryEvent } from '../../../../../services/eventingApi';
import { today } from '../shared/format';

export interface HistoryWindow {
  from: string;
  to: string;
}

export interface ReplayRequest {
  events: HistoryEvent[];
  window: HistoryWindow;
}

export const MAX_REPLAY = 100;
export const MAX_WINDOW_DAYS = 31;

const DAY_MS = 24 * 60 * 60 * 1000;

export const initialFilters = (): EventFilters => ({ from: today(), to: today(), size: 100 });

export const windowOf = (filters: EventFilters): HistoryWindow => ({ from: filters.from ?? today(), to: filters.to ?? today() });

export const windowError = (from?: string, to?: string): string | null => {
  if (!from || !to) return null;
  const days = (Date.parse(to) - Date.parse(from)) / DAY_MS;
  if (days < 0) return 'A data inicial não pode ser depois da final.';
  if (days >= MAX_WINDOW_DAYS) return `A janela pode ter no máximo ${MAX_WINDOW_DAYS} dias.`;
  return null;
};
